const GIFT_NOTE_MAX_LENGTH = 50;

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapProductId = this.dataset.giftWrapId;
    this.isGiftWrappingEnabled = this.dataset.giftWrapping;
    this.cartItemCount = parseInt(this.getAttribute("cart-items-size"));
    this.giftWrapItemCount = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.totalItemCount = parseInt(this.getAttribute("items-in-cart"));
    this.giftWrapMode = this.dataset.giftWrappingLimit;
    this.eligibleProducts = parseInt(this.getAttribute("data-eligible-count"));
    console.log(this.eligibleProducts - this.giftWrapItemCount);
    this.totalItems = this.eligibleProducts - this.giftWrapItemCount;
  }

  connectedCallback() {
    this.initializeGiftWrapCheckbox();
    this.handleInitialGiftWrapState();
  }

  initializeGiftWrapCheckbox() {
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener(
      "change",
      (event) => {
        event.target.checked ? this.addGiftWrap() : this.removeGiftWrap();
      },
    );
  }

  handleInitialGiftWrapState() {
    if (this.cartItemCount == 1 && this.giftWrapItemCount > 0) {
      return this.removeGiftWrap();
    }

    const targetGiftWraps = this.eligibleProducts - this.giftWrapItemCount;

    if (this.giftWrapItemCount > 0 && this.giftWrapItemCount !== targetGiftWraps) {
      if (targetGiftWraps <= 0) return this.removeGiftWrap();
      return this.addGiftWrap();
    }

    if (this.giftWrapItemCount > 0 && this.isGiftWrappingEnabled.length == 0) {
      return this.addGiftWrap();
    }
    if (this.giftWrapItemCount == 0 && this.isGiftWrappingEnabled.length > 0) {
      if (targetGiftWraps <= 0) return;
      return this.addGiftWrap();
    }
  }

  addGiftWrap() {
    const quantity = this.eligibleProducts - this.giftWrapItemCount;
    if (quantity <= 0) return this.removeGiftWrap();

    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: quantity,
      },
      { "gift-wrapping": true },
      sectionsToUpdate,
    );
    this.updateCart(requestBody);
  }

  removeGiftWrap() {
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 0,
      },
      { "gift-wrapping": "", "gift-note": "" },
      sectionsToUpdate,
    );
    this.updateCart(requestBody);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections },
      }),
    );
    return sections;
  }

  createRequestBody(updates, attributes, sections) {
    return JSON.stringify({ updates, attributes, sections });
  }

  updateCart(body) {
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: parsedState,
        });
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  showLoader() {
    const loaderElement = this.querySelector(".loader");
    if (loaderElement) loaderElement.classList.add("btn--loading");
  }
}
customElements.define("gift-wrapping", GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('[name="attributes[gift-note-enabled]"]');
    this.textarea = this.querySelector('[name="attributes[gift-note]"]');
    this.noteField = this.querySelector("[data-gift-note-field]");
    this.counter = this.querySelector("[data-gift-note-counter]");
    this.maxGiftNoteLength =
      parseInt(this.dataset.maxLength, 10) || GIFT_NOTE_MAX_LENGTH;

    if (!this.textarea || !this.toggle || !this.noteField) return;

    this.textarea.maxLength = this.maxGiftNoteLength;
    const initialGiftNote = this.getNormalizedGiftNote(this.textarea);
    this.updateCounter(initialGiftNote.length);
    this.debouncedSaveGiftNote = FoxTheme.utils.debounce(
      this.saveGiftNote.bind(this),
      300,
    );
    this.textarea.addEventListener("input", this.handleInput.bind(this));
    this.toggle.addEventListener(
      "change",
      this.updateGiftNoteToggle.bind(this),
    );
  }

  handleInput(event) {
    const giftNote = this.getNormalizedGiftNote(event.target);
    this.updateCounter(giftNote.length);
    if (this.toggle.checked) {
      this.debouncedSaveGiftNote(giftNote);
    }
  }

  getNormalizedGiftNote(target) {
    const giftNote = target.value.slice(0, this.maxGiftNoteLength);
    target.value = giftNote;
    return giftNote;
  }

  updateCounter(length) {
    if (!this.counter) return;
    this.counter.textContent = `${length}/${this.maxGiftNoteLength}`;
  }

  updateGiftNoteToggle(event) {
    const giftNoteEnabled = event.target.checked;
    this.noteField.hidden = !giftNoteEnabled;

    const attributes = giftNoteEnabled
      ? {
          "gift-note-enabled": "yes",
          "gift-note": this.getNormalizedGiftNote(this.textarea),
        }
      : { "gift-note-enabled": "", "gift-note": "" };

    if (!giftNoteEnabled) {
      this.textarea.value = "";
      this.updateCounter(0);
    }

    const requestBody = JSON.stringify({ attributes });
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body: requestBody },
    });
  }

  saveGiftNote(giftNote) {
    if (!this.toggle.checked) return;
    const requestBody = JSON.stringify({
      attributes: { "gift-note-enabled": "yes", "gift-note": giftNote },
    });
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body: requestBody },
    });
  }
}
customElements.define("gift-note", GiftNote);

class RemoveGiftWrapButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartItemsElement = this.closest("cart-items");
      cartItemsElement.showLoader(this.dataset.index);

      const giftWrappingElement = document.querySelector("gift-wrapping");
      giftWrappingElement.removeGiftWrap();
    });
  }
}
customElements.define("gift-wrap-remove-item", RemoveGiftWrapButton, {
  extends: "a",
});
